import { Grid, Typography, makeStyles } from '@material-ui/core';
import { DefaultButton } from 'design-system';

const useStyles = makeStyles(() => ({
  button: {
    marginBottom: 20,
  },
  descriptionText: {
    fontSize: 15,
    fontWeight: 400,
    color: '#555659',
  },
  errorText: {
    fontSize: 19,
    fontWeight: 900,
    marginBottom: 10,
  },
  image: {
    marginBottom: 10,
    marginTop: 10,
  },
}));

type Props = {
  onReset: () => void;
};

const LicenseErrorLayout = ({ onReset }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} container justifyContent="center">
        <Typography className={classes.errorText}>
          Oops.. algo salío mal
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <Typography className={classes.descriptionText}>
          Proceda sin digitar la placa e
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <Typography className={classes.descriptionText}>
          ingrese los datos de vehiculo manualmente
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <img
          src="/svg/conection_error.svg"
          alt="conection error"
          data-testid="error-layout-image"
          className={classes.image}
        />
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <Grid className={classes.button} item xs={12} md={8} lg={6}>
          <DefaultButton data-testid="reset-button" onClick={onReset} fullWidth>
            reintentar
          </DefaultButton>
        </Grid>
      </Grid>
      <Grid item xs={12} container justifyContent="center">
        <Typography className={classes.descriptionText}>
          Soporte técnico: soporteventasautocr@assanet.com
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LicenseErrorLayout;
